module.exports = __webpack_public_path__ + "img/hdfc.e2fcdd83.webp";